<!--
 * @Author: WLL
 * @Date: 2020-04-14 12:06:58
 * @LastEditors: WLL
 * @LastEditTime: 2020-05-12 16:44:48
 * @Description: 主页
 -->
<template>
  <div class="home">
    <div class="home_above horizontal_container">
      <SjCard
        class="horizontal_item"
        v-for="(rankItem, key) in rankDataMap"
        :key="key"
      >
        <DisplayArea
          :title="rankItem.title"
          :iconClass="rankItem.iconClass"
          :iconSize="rankItem.iconSize"
          :iconColor="rankItem.iconColor"
          v-sj-loading="rankItem.loading"
          @more="onMore(rankItem)"
        >
          <common-table
            :row-pointer="false"
            :data="rankItem.data"
            :columns="rankItem.columns"
            :tableProps="rankItem.tableProps"
            :rank="true"
            @cell-click="param => onRankingItemClick(param)"
            center
          >
          </common-table>
        </DisplayArea>
      </SjCard>
    </div>
    <div class="home_below horizontal_container">
      <SjCard
        class="horizontal_item"
        v-for="(newItem, key) in newDataMap"
        :key="key"
      >
        <DisplayArea
          :title="newItem.title"
          v-sj-loading="newItem.loading"
          @more="onMore(newItem)"
        >
          <common-table
            :data="newItem.data"
            :columns="newItem.columns"
            :tableProps="newItem.tableProps"
            @cell-click="(param, column) => reportClickWrapper(param, key, column)"
          >
          </common-table>
        </DisplayArea>
      </SjCard>
    </div>
  </div>
</template>

<script>
import DisplayArea from "@/components/DisplayArea.vue";
import reportMixin from "@/views/mixins/reportMixin";
import CommonTable from "@/components/CommonTable/index";
export default {
  mixins: [reportMixin],
  components: {
    CommonTable,
    DisplayArea
  },
  data() {
    return {
      rankDataMap: {
        analyst: {
          title: "分析师预测排行（近3个月）",
          redirect: {
            name: "analyst"
          },
          iconClass: "icon_xh iconicon_ranking",
          iconSize: "14px",
          iconColor: "#f3a709",
          tableProps: {},
          columns: [
            {
              prop: "RESEARCHER",
              label: "分析师",
              center: true,
              customRender: this.analystRender
            },
            {
              prop: "RPT_SUM",
              label: "推荐个股数",
              align: "right",
              center: true
            },
            {
              prop: "AVG_RATE",
              label: "平均收益率",
              helpText: "根据研报推荐个股计算所得",
              align: "center",
              type: "rate",
              tag: "up_color",
              center: true
            }
          ],
          data: [],
          loading: false
        },
        organization: {
          title: "机构预测排行（近3个月）",
          redirect: {
            name: "organization"
          },
          iconClass: "icon_xh iconicon_ranking",
          iconSize: "14px",
          iconColor: "#ff5c47",
          tableProps: {},
          columns: [
            {
              prop: "COMPANYNAME",
              label: "机构",
              center: true,
              customRender: this.agencyRender
            },
            {
              prop: "RPT_SUM",
              label: "推荐个股数",
              align: "right",
              center: true
            },
            {
              prop: "TOP10",
              label: "Top10平均收益率",
              align: "center",
              helpText: "根据研报推荐个股计算所得",
              type: "rate",
              tag: "up_color",
              center: true
            }
          ],
          data: [],
          loading: false
        },
        industry: {
          title: "机构关注行业（近1个月）",
          redirect: {
            name: "industry"
          },
          iconClass: "icon_xh iconicon_ranking",
          iconSize: "14px",
          iconColor: "#c3a220",
          tableProps: {},
          columns: [
            {
              prop: "INDUNAME",
              label: "行业名称",
              customRender: this.normalRender//this.industryColumn
            },
            {
              prop: "RPT_SUM",
              label: "机构报告数量",
              align: "right",
              center: true
            },
            {
              prop: "TOP1_COMNAME",
              label: "热门机构",
              center: true,
              align: "center"
            }
          ],
          data: [],
          loading: false
        }
      },
      newDataMap: {
        stock: {
          title: "最新个股评级",
          redirect: {
            name: "stock"
          },
          tableProps: {},
          columns: [
            {
              prop: "PUBLISHDATE",
              label: "日期",
              minWidth: 120,
              width: 80,
              center: true,
              formatter: this.publishMDDateFormatter
            },
            {
              prop: "SECURITYNAME",
              label: "股票",
              center: true,
              minWidth: 100,
              customRender: this.stockRender
            },
            {
              prop: "REPORTTITLE",
              label: "标题",
              minWidth: 170,
              customRender: this.ellipsisPointerRender
            },
            {
              prop: "COMPANYNAME",
              label: "机构",
              center: true,
              minWidth: 100,
              customRender: this.agencyRender
            },
            {
              prop: "ALLRESEARCHER",
              label: "作者",
              center: true,
              minWidth: 80,
              customRender: this.researcherRender
            },
            {
              prop: "EMRATINGNAME",
              label: "评级",
              center: true,
              minWidth: 40,
              customRender: this.ratingRender
            },
            {
              prop: "ATTACHNAME",
              label: "附件",
              center: true,
              minWidth: 40,
              align: "center",
              customRender: this.pdfIconRender
            }
          ],
          data: [],
          loading: false
        },
        industry: {
          title: "最新行业评级",
          redirect: {
            name: "industry"
          },
          tableProps: {},
          columns: [
            {
              prop: "PUBLISHDATE",
              label: "日期",
              center: true,
              width: 80,
              formatter: this.publishMDDateFormatter
            },
            {
              prop: "INDUNAME",
              label: "行业",
              minWidth: 100,
              center: true,
              customRender: this.ellipsisRender
            },
            {
              prop: "REPORTTITLE",
              label: "标题",
              minWidth: 170,
              customRender: this.ellipsisPointerRender
            },
            {
              prop: "COMPANYNAME",
              label: "机构",
              center: true,
              minWidth: 100,
              customRender: this.agencyRender
            },
            {
              prop: "ALLRESEARCHER",
              label: "作者",
              center: true,
              minWidth: 80,
              customRender: this.researcherRender
            },
            {
              prop: "EMRATINGNAME",
              label: "评级",
              center: true,
              minWidth: 40
            },
            {
              prop: "ATTACHNAME",
              label: "附件",
              center: true,
              minWidth: 40,
              align: "center",
              customRender: this.pdfIconRender
            }
          ],
          data: [],
          loading: false
        }
      }
    };
  },
  created() {
    this.init();
  },
  methods: {
    onRankingItemClick(data) {
      console.log(data);
    },
    industryColumn(h, { row, column }) {
      return (
        <p class="one-line" title={row[column.prop]}>
          {row[column.prop]}
        </p>
      );
    },
    reportClickWrapper(params, key, column) {
      const property = column.property;
      if(["REPORTTITLE"].includes(property)){
        const data = {
          upstream_page_type: "首页",
          upstream_page_modular:
            key === "stock" ? "最新个股评级" : "最新行业评级",
          research_report_type: key === "stock" ? "个股" : "行业"
        };
        this.onReportClick(params, data);
      }
    },
    init() {
      this.getAnalystData();
      this.getOrganizationData();
      this.getIndustryData();
      this.getStockNewData();
      this.getIndustryNewData();
    },
    async getAnalystData() {
      const { analyst } = this.rankDataMap;
      try {
        analyst.loading = true;
        const { data } = await this.$apis.Home.getAnalystList();
        analyst.data = data;
      } finally {
        analyst.loading = false;
      }
    },
    async getOrganizationData() {
      const { organization } = this.rankDataMap;
      try {
        organization.loading = true;
        const params = {
          pageNo: 1,
          pageSize: 5,
          V_MONTH: 3,
          V_INDUCODE: "011"
        };
        const { data } = await this.$apis.Org.getAgencyList(params);
        organization.data = data;
      } finally {
        organization.loading = false;
      }
    },
    async getIndustryData() {
      const { industry } = this.rankDataMap;
      try {
        industry.loading = true;
        const { data } = await this.$apis.Home.getIndustryList();
        industry.data = data;
      } finally {
        industry.loading = false;
      }
    },
    async getStockNewData() {
      const { stock } = this.newDataMap;
      try {
        stock.loading = true;
        const { data } = await this.$apis.Home.getStockRating();
        stock.data = data;
      } finally {
        stock.loading = false;
      }
    },
    async getIndustryNewData() {
      const { industry } = this.newDataMap;
      try {
        industry.loading = true;
        const { data } = await this.$apis.Home.getIndustryRating();
        industry.data = data;
      } finally {
        industry.loading = false;
      }
    },
    onMore(data) {
      window.sendEvent("click_more", {
        page_type: "首页",
        tab_name: data.title.substring(
          0,
          data.title.indexOf("（") > -1
            ? data.title.indexOf("（")
            : data.title.length
        )
      });
      const link = this.$router.resolve({
        name: data.redirect.name,
        query: Object.assign({}, this.$route.query, {
          themeType: this.themeType
        })
      });
      window.open(link.href, "_blank");
    }
  }
};
</script>

<style lang="less">
.one-line {
  width: 100%;
  white-space: nowrap;
  .text-ellipsis();
}
</style>
<style lang="less" scoped>
@above-height: 260px;

.home {
  box-sizing: border-box;
  padding: 10px;
  display: flex;
  flex-direction: column;
  .home_above {
    height: @above-height;
    margin-bottom: 10px;
  }
  .home_below {
    flex: 1;
    min-height: 0;
  }
}
</style>
